if (!customElements.get('saunas-guide')) {
  customElements.define(
    'saunas-guide',
    class SaunasGuide extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initTabs();
        this.initSaunaRecommender();
        this.initRoiCalculator();
      }
      initTabs() {
        this.querySelectorAll('[data-tab]').forEach((tab) => {
          tab.addEventListener('click', () => {
            this.activateTab(tab);
          });
        });
      }
      activateTab(tab) {
        this.querySelectorAll('[data-tab]').forEach((t) => {
          t.classList.remove('active');
        });
        tab.classList.add('active');
        this.showTabContent(tab.dataset.tab);
      }
      showTabContent(tabName) {
        this.querySelectorAll('[data-tab-content]').forEach((content) => {
          content.classList.remove('active');
        });
        this.querySelector(`[data-tab-content="${tabName}"]`).classList.add('active');
      }
      initSaunaRecommender() {
        this.saunaRecommenderContainer = this.querySelector('.sauna-recommender'); // scope to component
        if (!this.saunaRecommenderContainer) return;

        // Elements from your HTML
        this.questionsEl = this.saunaRecommenderContainer.querySelector('.sauna-recommender--questions');
        this.qTitleEl = this.saunaRecommenderContainer.querySelector('.sauna-recommender--question');
        this.choicesWrap = this.saunaRecommenderContainer.querySelector('.sauna-recommender--choices');
        this.resultInfra = this.saunaRecommenderContainer.querySelector('.sauna-recommender--result.infrared-sauna');
        this.resultFinnish = this.saunaRecommenderContainer.querySelector('.sauna-recommender--result.traditional-finnish-sauna');

        // Ensure results start hidden
        [this.resultInfra, this.resultFinnish].forEach(el => el.style.display = 'none');

        // Questions model
        this.QUESTIONS = [
          {
            id: 1, title: 'Question 1: Where do you plan to install your sauna?', choices: [
              { label: 'Indoor (bathroom, spare room)', value: 'indoor', code: 1 },
              { label: 'Outdoor (backyard, patio)', value: 'outdoor', code: 2 },
              { label: 'Not sure yet', value: 'not-sure', code: 3 },
            ]
          },
          {
            id: 2, title: "Question 2: What's your budget range?", choices: [
              { label: 'Under $3,000', value: 'under-3k', code: 1 },
              { label: '$3,000 - $6,000', value: '3k-6k', code: 2 },
              { label: '$6,000 - $10,000', value: '6k-10k', code: 3 },
              { label: 'Over $10,000', value: 'over-10k', code: 4 },
            ]
          },
          {
            id: 3, title: 'Question 3: How comfortable are you with installation?', choices: [
              { label: 'I want plug-and-play', value: 'plug-play', code: 1 },
              { label: 'I can hire an electrician', value: 'hire-elec', code: 2 },
            ]
          },
          {
            id: 4, title: "Question 4: What's your primary goal?", choices: [
              { label: 'Health & wellness', value: 'health', code: 1 },
              { label: 'Relaxation & stress relief', value: 'relax', code: 2 },
              { label: 'Social/family time', value: 'social', code: 3 },
              { label: 'Property value', value: 'property', code: 4 },
            ]
          },
        ];

        // State (must live on `this` so decide() can read it)
        this.answers = { 1: null, 2: null, 3: null, 4: null };
        this.step = 1;

        // Click handlers
        this.choicesWrap.addEventListener('click', (e) => {
          const btn = e.target.closest('.sauna-recommender--choice');
          if (!btn) return;

          const code = Number(btn.dataset.code);
          this.answers[this.step] = code;

          if (this.step < this.QUESTIONS.length) {
            this.step += 1;
            this.renderQuestion(this.QUESTIONS[this.step - 1]);
          } else {
            const resultType = this.decide();
            this.showResult(resultType);
          }
        });

        this.saunaRecommenderContainer.addEventListener('click', (e) => {
          const restart = e.target.closest('.sauna-recommender--restart');
          if (!restart) return;
          // Reset
          this.answers = { 1: null, 2: null, 3: null, 4: null };
          this.step = 1;
          this.hideResults();
          this.questionsEl.style.display = 'block';
          this.qTitleEl.style.display = 'block';
          this.renderQuestion(this.QUESTIONS[0]);
        });

        this.renderQuestion(this.QUESTIONS[0]);
      }

      renderQuestion(q) {
        this.qTitleEl.textContent = q.title;
        this.choicesWrap.innerHTML = '';
        q.choices.forEach(choice => {
          const btn = document.createElement('button');
          btn.className = 'saunas-guide--section standard sauna-recommender--choice';
          btn.dataset.choice = choice.value;
          btn.dataset.code = String(choice.code);
          btn.type = 'button';
          btn.textContent = choice.label;
          this.choicesWrap.appendChild(btn);
        });
        this.choicesWrap.style.display = '';
        this.qTitleEl.style.display = '';
        this.hideResults();
      }

      hideResults() {
        this.resultInfra.style.display = 'none';
        this.resultFinnish.style.display = 'none';
      }

      showResult(type) {
        this.questionsEl.style.display = 'none';
        this.choicesWrap.style.display = 'none';
        this.qTitleEl.style.display = 'none';
        if (type === 'infrared') {
          this.resultInfra.style.display = 'block';
          this.resultFinnish.style.display = 'none';
        } else {
          this.resultInfra.style.display = 'none';
          this.resultFinnish.style.display = 'block';
        }
      }

      decide() {
        const q2 = this.answers[2]; // budget (1..4)
        const q3 = this.answers[3]; // install comfort (1=plug&play, 2=hire)
        const q4 = this.answers[4]; // goal (1..4)

        const goalIsHealthRelax = q4 === 1 || q4 === 2;
        const plugAndPlay = q3 === 1;
        const hireAndBudgetLow = q3 === 2 && (q2 === 1 || q2 === 2);

        return (goalIsHealthRelax && (plugAndPlay || hireAndBudgetLow)) ? 'infrared' : 'traditional';
      }

      initRoiCalculator() {
        // Scope to this component
        this.roiCalc = this.querySelector('.roi-calculator');
        if (!this.roiCalc) return;

        // Inputs
        this.roiSpaVisitsEl = this.roiCalc.querySelector('#spa-visits');
        this.roiSpaCostEl = this.roiCalc.querySelector('#spa-cost');
        this.roiSaunaCostEl = this.roiCalc.querySelector('#sauna-cost');
        this.roiKwhCostEl = this.roiCalc.querySelector('#electricity-cost');

        // Outputs
        this.roiAnnualSpaCostEl = this.roiCalc.querySelector('#roi-calculator--annual-spa-cost');
        this.roiAnnualElecCostEl = this.roiCalc.querySelector('#roi-calculator--annual-electricity-cost');
        this.roiBreakEvenEl = this.roiCalc.querySelector('#roi-calculator--break-even-point');
        this.roiFiveYearSavingsEl = this.roiCalc.querySelector('#roi-calculator--5-year-savings');

        // Config / assumptions (override with data-kwh-per-session on .roi-calculator)
        this.roiKWhPerSession = Number(this.roiCalc.dataset.kwhPerSession ?? 3.5);
        this.WEEKS_PER_YEAR = 52;

        // Bind events once on the container (delegated)
        ['input', 'change'].forEach(evt => {
          this.roiCalc.addEventListener(evt, (e) => {
            const id = e.target?.id;
            if (!id) return;
            if (!['spa-visits', 'spa-cost', 'sauna-cost', 'electricity-cost'].includes(id)) return;
            this.roiCalculate();
          });
        });

        // Initial render
        this.roiCalculate();
      }

      roiClamp(val, min, max) {
        return Math.min(max, Math.max(min, val));
      }

      roiFmtMoney0(n) {
        return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 }).format(n);
      }

      roiFmtMoney2(n) {
        return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
      }

      roiReadInputs() {
        // read & clamp
        const clamp = (val, min, max) => Math.min(max, Math.max(min, val));
        const v = Number(this.roiSpaVisitsEl.value || 0);
        const c = Number(this.roiSpaCostEl.value || 0);
        const p = Number(this.roiSaunaCostEl.value || 0);
        const e = Number(this.roiKwhCostEl.value || 0);
        return {
          visitsPerWeek: clamp(v, Number(this.roiSpaVisitsEl.min || 0), Number(this.roiSpaVisitsEl.max || 999)),
          costPerVisit: clamp(c, Number(this.roiSpaCostEl.min || 0), Number(this.roiSpaCostEl.max || 1e6)),
          saunaPrice: clamp(p, Number(this.roiSaunaCostEl.min || 0), Number(this.roiSaunaCostEl.max || 1e9)),
          kWhPrice: clamp(e, Number(this.roiKwhCostEl.min || 0), Number(this.roiKwhCostEl.max || 1e3)),
        };
      }

      roiCalculate() {
        // Franks reverse engineering formula that was originally created by AI
        const { visitsPerWeek, costPerVisit, saunaPrice, kWhPrice } = this.roiReadInputs();

        // Spa
        const annualSpaCost = visitsPerWeek * costPerVisit * 52;     // annual spa cost
        const fiveYearSpaCost = annualSpaCost * 5;                      // 5 year spa cost

        // Electricity (independent of visits; price-per-kWh × 365 days)
        const annualElecRaw = kWhPrice * 365;                         // annual electricity cost (unrounded)
        const annualElecDisp = Math.round(annualElecRaw);              // annual electricity costs (rounded for display)
        const fiveYearElec = annualElecRaw * 5;                      // 5 year electricity cost (NOT rounded)

        // 5-year savings = +5yr spa − purchase − 5yr electricity
        const fiveYearSavings = fiveYearSpaCost - saunaPrice - fiveYearElec;

        // Break-even
        const monthlySpaCost = annualSpaCost / 12;
        const breakEvenMonthsExact = monthlySpaCost > 0 ? (saunaPrice / monthlySpaCost) : Infinity;
        const breakEvenMonthsRounded = isFinite(breakEvenMonthsExact)
          ? Math.round(breakEvenMonthsExact * 10) / 10                  // rounded to 1 decimal
          : Infinity;

        // ----- Render -----
        const money0 = (n) => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 }).format(n);
        const money2 = (n) => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);

        if (this.roiAnnualSpaCostEl) this.roiAnnualSpaCostEl.textContent = money0(annualSpaCost);
        if (this.roiAnnualElecCostEl) this.roiAnnualElecCostEl.textContent = money0(annualElecDisp);
        if (this.roiBreakEvenEl) this.roiBreakEvenEl.textContent = isFinite(breakEvenMonthsRounded) ? `${breakEvenMonthsRounded.toFixed(1)} months` : '—';
        if (this.roiFiveYearSavingsEl) this.roiFiveYearSavingsEl.textContent = money2(fiveYearSavings);
      }

    }
  );
}